import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { environment as env } from '../../../environments/environment';
import { VersionTagComponent } from '../version-tag/version-tag.component';

@Component({
  selector: 'app-login-layout',
  imports: [RouterModule, CommonModule, VersionTagComponent],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss'
})
export class LoginLayoutComponent {
  protected readonly env = env;
  protected year: number;

  constructor() {
    this.year = new Date().getFullYear();
  }
}
